/**
 * THE SPECIFICATION SHEET — the tab the merchant has and we did not.
 *
 * Their product page carries four tabs; ours carried two, and the facts a
 * watch buyer looks up before paying were in our database with no screen to
 * show them: the SKU that matches the box and the warranty card, the brand on
 * a shop called "House of Brands", the row they chose, and the weight and box
 * size where the shop has measured them.
 *
 * `buildProductSpecs` returns rows only where there are values, and this
 * renders nothing at all for an empty list — the page uses the same emptiness
 * to leave the whole tab out. An empty "Specifications" tab is worse than none.
 */
import React from 'react';
import styles from './styles.module.css';

const SpecificationsSection = ({ rows, isRtl, id }) => {
  if (!rows || !rows.length) return null;
  return (
    <dl
      id={id}
      dir={isRtl ? 'rtl' : 'ltr'}
      className={styles.specList}
      data-testid="product-detail-spec-sheet"
    >
      {rows.map((row) => (
        <div key={row.key} className={styles.specRow} data-testid={`product-detail-spec-${row.key}`}>
          <dt className={styles.specLabel}>{row.label}</dt>
          {/* `dir="auto"` per VALUE, not per row: `DK.1.14401-1` and
            * `12 × 9 × 6 cm` are left-to-right runs sitting in a right-to-left
            * sheet, and letting each one state its own direction is what keeps
            * a model number from coming apart around its hyphen. */}
          <dd className={styles.specValue} dir="auto">{row.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default SpecificationsSection;
